"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentType = void 0;
var ContentType;
(function (ContentType) {
    ContentType["ALL"] = "ALL";
    ContentType["LOOPS"] = "LOOPS";
    ContentType["MUSIC"] = "MUSIC";
    ContentType["SOUND_EFFECTS"] = "SOUND_EFFECTS";
    ContentType["ILLUSTRATIONS"] = "ILLUSTRATIONS";
    ContentType["PHOTOS"] = "PHOTOS";
    ContentType["SNAPSHOTS"] = "SNAPSHOTS";
    ContentType["VECTORS"] = "VECTORS";
    ContentType["FOOTAGE"] = "FOOTAGE";
    ContentType["MOTION_BACKGROUNDS"] = "MOTION_BACKGROUNDS";
    ContentType["TEMPLATES"] = "TEMPLATES";
    ContentType["VR_360"] = "VR_360";
    ContentType["OUTDATED_SCHEMA"] = "OUTDATED_SCHEMA";
})(ContentType || (exports.ContentType = ContentType = {}));
//# sourceMappingURL=ContentTypeEnum.js.map